import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { ToastComponent } from '../../app/content/layout/components/general/toast/toast.component';
import { ToastService } from '../../app/core/services/toast.service';
import { withCommonDecorators } from '../_utils/story-helpers';

function createToastService(toasts: any[]) {
  const service = new ToastService();
  service.toasts = toasts;
  return { provide: ToastService, useValue: service };
}

const meta: Meta<ToastComponent> = {
  title: 'Atoms/Toast',
  component: ToastComponent,
  parameters: {
    layout: 'padded',
    docs: {
      description: {
        component: 'Toast notification component using NgbToast. Displays success, error, and default messages.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<ToastComponent>;

export const DefaultToast: Story = {
  decorators: [
    ...withCommonDecorators([
      createToastService([{ textOrTpl: 'Produktet er tilføjet til kurven', delay: 5000 }]),
    ]),
  ],
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-toast')).toBeTruthy();
  },
};

export const SuccessToast: Story = {
  decorators: [
    ...withCommonDecorators([
      createToastService([{ textOrTpl: 'Din ordre er gennemført!', classname: 'bg-success text-light', delay: 5000 }]),
    ]),
  ],
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-toast')).toBeTruthy();
  },
};

export const DangerToast: Story = {
  decorators: [
    ...withCommonDecorators([
      createToastService([{ textOrTpl: 'Der opstod en fejl. Prøv igen.', classname: 'bg-danger text-light', delay: 5000 }]),
    ]),
  ],
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-toast')).toBeTruthy();
  },
};

export const MultipleToasts: Story = {
  decorators: [
    ...withCommonDecorators([
      createToastService([
        { textOrTpl: 'Château Margaux tilføjet til kurven', delay: 5000 },
        { textOrTpl: 'Barolo Riserva tilføjet til kurven', classname: 'bg-success text-light', delay: 5000 },
        { textOrTpl: 'Kun 3 flasker tilbage!', classname: 'bg-danger text-light', delay: 5000 },
      ]),
    ]),
  ],
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-toast')).toBeTruthy();
  },
};

export const Empty: Story = {
  decorators: [
    ...withCommonDecorators([
      createToastService([]),
    ]),
  ],
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-toast')).toBeTruthy();
  },
};
